import React from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Users, Activity, Stethoscope, FlaskConical, Scan, Pill, CheckCircle } from 'lucide-react';
export const AdminDashboard: React.FC = () => {
  const {
    users,
    patients,
    encounters
  } = useData();
  const activeEncounters = encounters.filter(e => e.stage !== 'COMPLETED');
  const stats = {
    totalStaff: users.length,
    totalPatients: patients.length,
    activeEncounters: activeEncounters.length,
    withNursing: encounters.filter(e => e.stage === 'NURSING').length,
    withClinician: encounters.filter(e => e.stage === 'CLINICIAN').length,
    labOrdered: encounters.filter(e => e.stage === 'INVESTIGATIONS' && e.pendingLab).length,
    radOrdered: encounters.filter(e => e.stage === 'INVESTIGATIONS' && e.pendingRadiology).length,
    withPharmacy: encounters.filter(e => e.stage === 'PHARMACY').length,
    completedToday: encounters.filter(e => e.stage === 'COMPLETED' && new Date(e.startedAt).toDateString() === new Date().toDateString()).length
  };
  const StatCard = ({
    title,
    value,
    icon: Icon,
    colorClass
  }: any) => <div className="bg-white overflow-hidden shadow rounded-lg border border-gray-200" data-id="element-95">
      <div className="p-5" data-id="element-96">
        <div className="flex items-center" data-id="element-97">
          <div className="flex-shrink-0" data-id="element-98">
            <Icon className={`h-6 w-6 ${colorClass}`} aria-hidden="true" data-id="element-99" />
          </div>
          <div className="ml-5 w-0 flex-1" data-id="element-100">
            <dl data-id="element-101">
              <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-102">
                {title}
              </dt>
              <dd data-id="element-103">
                <div className="text-2xl font-bold text-gray-900" data-id="element-104">{value}</div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>;
  return <div className="space-y-6" data-id="element-105">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-106">System Overview</h1>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-107">
        <StatCard title="Total Staff" value={stats.totalStaff} icon={Users} colorClass="text-blue-500" data-id="element-108" />
        <StatCard title="Total Registered Patients" value={stats.totalPatients} icon={Users} colorClass="text-green-500" data-id="element-109" />
        <StatCard title="Active Encounters" value={stats.activeEncounters} icon={Activity} colorClass="text-red-500" data-id="element-110" />
      </div>

      <h2 className="text-lg font-medium text-gray-900 mt-8" data-id="element-111">
        Current Department Load
      </h2>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-112">
        <StatCard title="Waiting Nursing" value={stats.withNursing} icon={Activity} colorClass="text-blue-500" data-id="element-113" />
        <StatCard title="Waiting Clinician" value={stats.withClinician} icon={Stethoscope} colorClass="text-indigo-500" data-id="element-114" />
        <StatCard title="Pending Lab" value={stats.labOrdered} icon={FlaskConical} colorClass="text-yellow-500" data-id="element-115" />
        <StatCard title="Pending Radiology" value={stats.radOrdered} icon={Scan} colorClass="text-purple-500" data-id="element-116" />
        <StatCard title="Waiting Pharmacy" value={stats.withPharmacy} icon={Pill} colorClass="text-teal-500" data-id="element-117" />
        <StatCard title="Completed Today" value={stats.completedToday} icon={CheckCircle} colorClass="text-green-500" data-id="element-118" />
      </div>
    </div>;
};